import Login from "@/pages/Login";
import Layout from "@/pages/Layout";
import NotFound from "@/pages/NotFound";
import AuthRoute from "@/components/AuthRoute";
import Register from "@/pages/Register";
import UserAgreement from "@/pages/UserAgreement";
import ForgetPassword from "@/pages/ForgetPassword";
import Main from "@/pages/Main";
import Canteen from "@/pages/Canteen";
import NoticeParticulars from "@/pages/NoticeParticulars";
import Search from "@/pages/Search";
import CanteenDetails from "@/pages/CanteenDetails";
import Detail from "@/pages/Detail";
import Pay from '@/pages/Pay'
import Info from "@/pages/Info";
import Order from "@/pages/Order";
import ResetPwd from '@/pages/ResetPwd'
import SubOrderForm from "@/pages/SubOrderForm";
import SubOrderCommit from "@/pages/SubOrderCommit";
import { createBrowserRouter } from "react-router-dom";
import OrderDetail from "@/pages/OrderDetail";
import DiningCompleted from "@/pages/DiningCompleted";
import Transfer from "@/pages/Transfer";
import TransferDetail from "@/pages/TransferDetail";
import TransferOrderCommit from "@/pages/TransferOrderCommit";
import TransferOrder from "@/pages/TransferOrder";
import Feedback from "@/pages/Feedback";
import Collect from '@/pages/Collect'
import TransferOrderDetail from "@/pages/TransferOrderDetail";
import BindPhone from "@/pages/BindPhone";
import VisitReport from "@/pages/VisitReport";
import ImproveInfo from '@/pages/ImproveInfo'

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <AuthRoute>
        <Layout />
      </AuthRoute>
    ),
    children: [
      {
        // path: '/main',
        index: true,
        element: <Main />,
      },
      {
        path: "/canteen",
        element:
        
            <Canteen />,

      },
      {
        path: "/transfer",
        element: <Transfer />,
      },
      {
        path: "/transferDetail",
        element: <TransferDetail />,
      },
      {
        path: "/transferOrderCommit",
        element: <TransferOrderCommit />,
      },
      {
        path: '/transferOrderDetail',
        element: <TransferOrderDetail />,
      },
      {
        path: "/noticeParticulars",
        element: <NoticeParticulars />,
      },
      {
        path: "/search",
        element: <Search />,
      },
      {
        path: "/canteenDetails",
        element: <CanteenDetails />,
      },
      {
        path: "/detail",
        element: <Detail />,
      },
      {
        path: "/pay",
        element: <Pay />,
      },
      {
        path: "/info",
        element: <Info />,
      },
      {
        path: '/improveInfo',
        element:<ImproveInfo/>
      },
      {
        path: "/feedback",
        element: <Feedback />,
      },
      {
        path: "/order",
        element: <Order />,
      },
      {
        path: "/orderDetail",
        element: <OrderDetail />,
      },
      {
        path: "/transferOrder",
        element: <TransferOrder />,
      },
      {
        path: "/diningCompleted",
        element: <DiningCompleted />,
      },
      {
        path: '/resetPwd',
        element: <ResetPwd />
      },
      {
        path: '/bindPhone',
        element: <BindPhone />
      },
      {
        path: "/subOrderForm",
        element: <SubOrderForm />,
      },
      {
        path: "/subOrderCommit",
        element: <SubOrderCommit />,
      },
      {
        path: '/collect',
        element: <Collect />,
      }
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/userAgreement",
    element: <UserAgreement />,
  },
  {
    path: "/forgetPassword",
    element: <ForgetPassword />,
  },
  {
    path: "/visitReport",
    element: <VisitReport />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export default router;
